const autoComplete = require("@tarekraafat/autocomplete.js");

const autoCompleteJS = new autoComplete({
  submit: true,
  threshold: 3,
  data: {
    src: async (query) => {
      try {
        const source = await fetch(`/?type=7384&tx_solr%5BqueryString%5D=${query}`);
        const response = await source.json();

        if (typeof response.suggestions !== 'undefined') {
            return Object.keys(response.suggestions);
        }

        return [];
      } catch (error) {
        return error;
      }
    },
  },
  searchEngine: (q, r) => r,
  resultItem: {
    highlight: true
  },
  events: {
    input: {
      selection: (event) => {
        const selection = event.detail.selection.value;
        autoCompleteJS.input.value = selection;
      }
    }
  }
});
